export default __webpack_public_path__ + "static/media/type-underline.b41f84ac.svg";